document.addEventListener( 'DOMContentLoaded', function () {
	let slickContainer = jQuery( '.slider-wrapper' );
	if( typeof slickContainer.slick === 'function' ) {
		slickContainer.slick({
			dots: false,
			infinite: false,
			arrows: false,
			slidesToShow: 3,
			centerMode: false,
			variableWidth: true,
			swipe: true,
			responsive: [
				{
					breakpoint: 768, // Adjust this value based on your design
					settings: {
						slidesToShow: 1, // Show 1 slide on mobile
					}
				}
			]
		});
	}
} );
